import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getReviewDetailList = createAsyncThunk(
  "reviewDetailList/getReviewDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/review/get_all_data`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const reviewDetailSlice = createSlice({
  name: "reviewDetailList",
  initialState: {
    loading: false,
    reviewDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReviewDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReviewDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewDetailData = action.payload;
      })
      .addCase(getReviewDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reviewDetailSlice.reducer;
